import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import PageBanner from "../layout/PageBanner";
import { catalogService } from "../services";
import { Panel, Skeleton } from "../components/ui";

export default function Policy() {
  const [sections, setSections] = useState(null);

  useEffect(() => {
    let alive = true;
    catalogService.policy().then((data) => alive && setSections(data || []));
    return () => {
      alive = false;
    };
  }, []);

  return (
    <Layout>
      <PageBanner title="นโยบายความเป็นส่วนตัว" breadcrumb={[{ label: "นโยบายความเป็นส่วนตัว" }]} seed={17} />

      <div className="lucid-container" style={{ marginTop: -30, position: "relative", zIndex: 3, paddingBottom: 40 }}>
        <Panel>
          {!sections ? (
            <Skeleton height={420} />
          ) : (
            <div className="lt-article">
              {sections.map((section) => (
                <section key={section.title} style={{ marginBottom: 26 }}>
                  <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 10 }}>{section.title}</h3>
                  {section.body.map((line, index) => (
                    <p key={index}>• {line}</p>
                  ))}
                </section>
              ))}
            </div>
          )}
        </Panel>
      </div>
    </Layout>
  );
}
